import { apiService } from "./api";

export interface CreateCheckoutSessionRequest {
  productId: string;
  productName: string;
  price: string;
  currency: string;
  quantity?: number;
  orderId?: string;
  billingInterval?: string;
  customerEmail?: string;
  preferredMethod?: 'card' | 'oxxo' | 'spei';
}

export interface CheckoutSessionResponse {
  url: string;
  sessionId: string;
  orderId?: string;
}

export interface CheckoutSessionStatus {
  status: string;
  customerEmail?: string;
}

export const createCheckoutSession = async (
  data: CreateCheckoutSessionRequest
): Promise<CheckoutSessionResponse> => {
  try {
    return await apiService.post<CheckoutSessionResponse>(
      '/payments/stripe/create-session',
      data
    );
  } catch (error: any) {
    console.error('Error creating checkout session:', error);
    throw new Error(
      error.message || 'Error al crear la sesión de pago'
    );
  }
};


/**
 * Redirige al usuario a Stripe Checkout
 */
export const redirectToCheckout = async (
  data: CreateCheckoutSessionRequest
): Promise<void> => {
  try {
    const { url } = await createCheckoutSession(data);
    window.location.href = url;
  } catch (error) {
    console.error('Error redirecting to checkout:', error);
    throw error;
  }
};


const stripeService = {
  createCheckoutSession,
  redirectToCheckout,
};

export default stripeService;